import React from 'react'
import { twMerge } from 'tailwind-merge'
import { TWrapperComponent } from '../types'

const Container = React.forwardRef((
    {children, className, id}: TWrapperComponent, 
    ref: React.ForwardedRef<HTMLDivElement>) => {
    return (
        <div id={id} ref={ref} className={twMerge('px-6 w-full max-w-full xl:w-[1100px] xl:mx-auto', className)}>
            {children}
        </div>
    )
})

export default Container